import React from 'react';
import { useLanguage } from '../../../contexts/LanguageContext';
import type { ChatFlowPendingNotice } from '../../../services/chatFlowApi';
import './InvitationUpdateNoticeModal.css';

export interface InvitationUpdateNoticeModalProps {
  notice: ChatFlowPendingNotice;
  onDismiss: () => void;
}

const InvitationUpdateNoticeModal: React.FC<InvitationUpdateNoticeModalProps> = ({
  notice,
  onDismiss,
}) => {
  const { t } = useLanguage();
  const bodyLines = notice.body.split('\n');

  return (
    <div className="invitation-update-notice" role="dialog" aria-modal="true" aria-labelledby="invitation-update-notice-title">
      <div className="invitation-update-notice__backdrop" aria-hidden />
      <div className="invitation-update-notice__card">
        <h2 id="invitation-update-notice-title" className="invitation-update-notice__title">
          {notice.title}
        </h2>
        <p className="invitation-update-notice__body">
          {bodyLines.map((line, i) => (
            <React.Fragment key={i}>
              {line}
              {i < bodyLines.length - 1 && <br />}
            </React.Fragment>
          ))}
        </p>
        <button type="button" className="invitation-update-notice__btn" onClick={onDismiss}>
          {t('submitDocuments.invitationUpdateNotice.dismiss')}
        </button>
      </div>
    </div>
  );
};

export default InvitationUpdateNoticeModal;
